const Action = (props) => {
   const { onDelete, onCopy } = props;
   return (
      <div className="card-action-container">
         <a onClick={onDelete}>
            <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="times" className="svg-inline--fa fa-times fa-w-11 card-action mt5" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
               <path fill="currentColor"
                  d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
               </path>
            </svg>
         </a>
         {/* <a>
            <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="arrow-up" className="svg-inline--fa fa-arrow-up fa-w-14 card-action mt5 text-smaller" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
               <path fill="currentColor"
                  d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z">
               </path>
            </svg>
         </a>
         <a>
            <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="arrow-down" className="svg-inline--fa fa-arrow-down fa-w-14 card-action mt5 text-smaller" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
               <path fill="currentColor"
                  d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z">
               </path>
            </svg>
         </a> */}
         <a onClick={onCopy}>
            <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="clone" className="svg-inline--fa fa-clone fa-w-16 card-action ml-2 mt8" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
               <path fill="currentColor"
                  d="M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z">
               </path>
            </svg>
         </a>
      </div>
   )
}

export default Action;